/**
 * @fileoverview POST handler for the "/engagement/segments/:app_group_id/mark_as_archived" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentsMarkAsArchivedCacheKeys } from "./constants";
import type { SegmentsArchiveResult, SegmentsUndoRestoreResult, SegmentsArchiveProps } from "./types";
import type { SuppressionListErrors } from "./types";

export const postEngagementSegmentsMarkAsArchived = reactQueryMutationAdapter(
  engagementSegmentsMarkAsArchivedCacheKeys,
  createMutationFetcherFunctionWithShadowError<SuppressionListErrors>()(
    (props: SegmentsArchiveProps): Promise<SegmentsArchiveResult | SegmentsUndoRestoreResult> => {
      return fetch(`/engagement/segments/${props.app_group_id}/mark_as_archived`, "POST", {
        segment_ids: props.segment_ids,
        app_group_id: props.app_group_id,
        undo_identifier: props.undo_identifier,
        type: props.type,
      });
    }
  )
);
